import { RootState } from '@dashboard/store'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import Component, { StateProps, DispatchProps, OwnProps } from './component'
import { AnyAction, bindActionCreators } from 'redux'
import { loadCelebrities } from '@dashboard/store/actions/celebrities/public'

const mapStateToProps = (states: RootState): StateProps => {
  const { getCelebrityResults, getCelebrityStates } = states.celebrities
  const { createImageResults, createImageStates } = states.image

  return {
    getCelebrityResults,
    getCelebrityStates,
    createImageResults,
    createImageStates,
  }
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
): DispatchProps => {
  dispatch
  return {
    loadCelebrities: bindActionCreators(loadCelebrities, dispatch),
  }
}

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps,
)(Component)
